<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row class="fill-height" justify="start">
        <v-col cols="12">
          <v-card color="#1976d2">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  Медиа
                </h3>
              </div>
            </v-card-title>
          </v-card>
          <v-card>
            <v-col cols="12">
              <div class="text-center">
                <v-dialog
                  v-model="loading"
                  persistent
                  width="300">
                  <v-card
                    color="primary"
                    dark>
                    <v-card-text>
                      Загружаются данные отчета
                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0" />
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
              <v-row align="center" justify="center">
                <BaseControlElement :lowest-date.sync="lowestDate"
                                    :highest-date.sync="highestDate"
                                    @submitSearch="submitSearch('initial')" />
              </v-row>
              <v-row>
                <!--                <v-text-field-->
                <!--                  ref="volunteer"-->
                <!--                  v-model="keyWords"-->
                <!--                  style="margin-left: 20px"-->
                <!--                  label="Волонтеры" />-->
                <v-combobox
                  v-model="keyWords"
                  label="Ключевые слова"
                  multiple
                  chips
                  style="margin-left:20px; margin-right:20px" />
              </v-row>
              <v-row align="end" justify="end">
                <v-btn color="primary" class="mb-2" @click="submitSearch('search')">
                  Обновить
                </v-btn>
              </v-row>
            </v-col>
            <!--<v-card-title primary-title>-->
            <!--<div>-->
            <!--<h3 class="headline mb-0">Сводный отчет о полевой работе сотрудников</h3>-->
            <!--</div>-->

            <!--</v-card-title>-->

            <ReportTable :data="tableData"
                         :headers="computedHeaders"
                         :loading="loading"
                         :is-searchable="true"
                         :is-dragable="false"
                         :sort-by="['published','title', 'source']"
                         :column-types-mapping="columnTypesMapping"
                         item-key="title"
                         table-name="Медиа" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import ReportTable from '../ReportTable'
import BaseControlElement from '../../base/BaseControlElement'

import {authHeader} from '../../../_helpers/auth-header'

export default {
  name: "ReportMedia",
  components: {
    ReportTable,
    BaseControlElement
  },
  props: {
    report: {
      type: String
    }
  },
  data () {
    return {
      errorMessages: '',
      keyWords: ["anya sarang", "andrey rylkov foundation", "аня саранг", "фонд андрея рылькова"],
      loading: false,
      tableData: [],
      lowestDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      highestDate: new Date().toISOString().substr(0, 10),
      headers: [
        // {text: '', value: 'importance', align: 'd-none', class:['d-none']},
        {text: 'Дата', value: 'published', align: 'left', sortable: true, width:'10%'},
        {text: 'Заголовок', value: 'title', align: 'left', sortable: true, width:'30%'},
        // {text: 'Текст', value: 'text', align: 'd-none', sortable: true},
        {text: 'Ссылка', value: 'link', align: 'left', sortable: true, width:'10%'},
        {text: 'Авторы', value: 'authors', align: 'left', sortable: true, width:'10%'},
        {text: 'Источник', value: 'source', align: 'left', sortable: true, width:'10%'},
        {text: 'Ключевые слова', value: 'keywords', align: 'left', sortable: false, width:'10%'}
      ],
      loaded: false,
      columnTypesMapping: {
                  'link':{'type':'url'},
                  'source':{'type':'url','text':'orig'},
                  'published':  {'type':'date'}
      }
    }
  },
  computed: {
     computedHeaders () {
      return this.headers.filter(f => { return f.align !== 'd-none' })
   },
   },

  // mounted () {
  //   this.submitSearch('initial')
  // },
  methods: {
    submitSearch (type) {
      this.loading = true
      const requestOptions = {
        headers: authHeader()
      }
      let url = type==='initial' ? this.$store.state.tableData.backend + '/report/media_initial' :
        this.$store.state.tableData.backend + '/report/media'

      axios({
        url: url,
        headers: requestOptions['headers'],
        method: 'post',
        data: {
          lowestDate: this.lowestDate,
          highestDate: this.highestDate,
          keywords: this.keyWords,
        }
      }).then((response) => {
        this.loading = false
        this.tableData = response.data.table

      }).catch((error) => {
        throw new Error(`You can't load the data`)
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/pages/ReportMedia.vue